// extracted by mini-css-extract-plugin
export default {"containerSucess":"Success_containerSucess__zdCeT"};